import React from 'react'
import { IssuingAccountFundingApi } from './issuingAccountFundingApi'

export const IssuingAccountFunding = () => {
  return (
    <IssuingAccountFundingApi />
  )
}
